import { THETA_MARKETPLACE_WALLET_ADDRESS } from '@wolffun/shared/constants';
import thetanCoinContract from '@wolffun/shared/src/contracts/thetaCoin';
import busdContract from '@wolffun/shared/src/contracts/busd';
import wbnbContract from '@wolffun/shared/src/contracts/wbnb';
import thetanGemContract from '@wolffun/shared/src/contracts/thetaGem';
import { blockchainNumberToSystemCurrency, CurrencyType, systemCurrencyToBlockchainNumber } from '@wolffun/system-currency';
import { EipError } from '../redux/types';
import { BN } from 'bn.js';
import { getGasPrice } from '@wolffun/shared/src/utils/ethereum.util';
export { personalSign, hashMessage } from '@wolffun/shared/src/utils/ethereum';

const getContract = type => {
  switch (type) {
    case CurrencyType.BUSD:
      return busdContract;

    case CurrencyType.WBNB:
      return wbnbContract;

    case CurrencyType.THC:
      return thetanCoinContract;

    case CurrencyType.THG:
      return thetanGemContract;

    default:
      throw new Error('Currency contract is not supported!');
  }
};

export const removeAllowance = async ({
  contractAddress,
  fromAddress,
  token
}) => {
  const contract = await getContract(token).getContract();

  try {
    const gasPrice = await getGasPrice();
    const allowance = await contract.methods.allowance(fromAddress, contractAddress).call();
    const allowanceSC = blockchainNumberToSystemCurrency(CurrencyType.THC, new BN(allowance));
    const allowanceBN = new BN(allowanceSC.value);
    const amountBN = new BN('0');

    if (allowanceBN.gt(amountBN)) {
      await contract.methods.approve(contractAddress, systemCurrencyToBlockchainNumber({
        token: token,
        value: '0'
      })).send({
        from: fromAddress,
        gasPrice
      });
    }

    return {
      error: EipError.NO_ERROR
    };
  } catch (err) {
    if (err.code) {
      return {
        error: err.code
      };
    } else {
      return {
        error: EipError.UNSUPPORTED_METHOD
      };
    }
  }
};
export const getAllowance = async ({
  contractAddress,
  fromAddress,
  token
}) => {
  const contract = await getContract(token).getContract();

  try {
    const allowance = await contract.methods.allowance(fromAddress, contractAddress).call();
    const allowanceSC = blockchainNumberToSystemCurrency(CurrencyType.THC, new BN(allowance));
    return {
      error: EipError.NO_ERROR,
      allowance: allowanceSC
    };
  } catch (err) {
    if (err.code) {
      return {
        error: err.code
      };
    } else {
      return {
        error: EipError.UNSUPPORTED_METHOD
      };
    }
  }
};
export const approveContract = async (address, amount, toAddress) => {
  const contract = await getContract(amount.token).getContract();

  try {
    const gasPrice = await getGasPrice();
    await contract.methods.approve(toAddress || THETA_MARKETPLACE_WALLET_ADDRESS, systemCurrencyToBlockchainNumber({
      token: amount.token,
      value: ['1', ...new Array(30).fill('0')].join('')
    })).send({
      from: address,
      gasPrice
    });
    return {
      error: EipError.NO_ERROR
    };
  } catch (err) {
    if (err.code) {
      return {
        error: err.code
      };
    } else {
      return {
        error: EipError.UNSUPPORTED_METHOD
      };
    }
  }
};